import TextCreate from 'core/display/simple/Text'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'
import { delayCallBack } from 'utils/Delay'

export default class NetPositionText extends TextCreate{
  constructor(data) {
    super(data)
    this.netPosition = { value: 0 }

    signal.once('INIT:REGULAR', this.start.bind(this))
    signal.once('INIT:FREESPINS', this.startFS.bind(this))
    signal.on('STATE:IN:FS-START', this.startFS.bind(this))
    signal.on('STATE:OUT:FS-END', this.start.bind(this))
    signal.on('STATE:IN:RESPIN', this.joinRespin.bind(this))
    signal.on('STATE:OUT:RESPIN', this.start.bind(this))
  }

  reset(){

    delayCallBack(0.2, () => {
      this.onUpdate()
      this.netPosition.value = 0
      this.onUpdate()
    }).then(() => {
      gsap.killTweensOf(this.netPosition)
    })
  }

  start() {
    this.onUpdate()
    if (game.models.BonusMultiplierModel.isFS) {
      signal.off('ACTION:REEL-SPIN', this.spin)
    }
    else {
      signal.on('ACTION:REEL-SPIN', this.spin.bind(this))
      signal.on('WIN-COLLECT-GAMBLE:WIN', this.gambleEnd.bind(this))
      signal.on('WIN-COLLECT-GAMBLE:LOSE', this.gambleEnd.bind(this))
      signal.on('BUTTON:BuyButton', this.tryBuyFeature.bind(this))
      signal.on('CASCADE-WIN-UPDATE-COUNTER', this.cascadeWin.bind(this))
      signal.on('WIN-COLLECT', this.win.bind(this))
      signal.once('NET:POSITION:CLEAN', this.reset.bind(this))
    }
  }

  joinRespin() {
    this.onUpdate()
    signal.off('ACTION:REEL-SPIN', this.spin)
  }

  startFS() {
    this.onUpdate()
    signal.off('ACTION:REEL-SPIN', this.spin)
    signal.on('WIN-COLLECT', this.win.bind(this))
    signal.on('CASCADE-WIN-UPDATE-COUNTER', this.cascadeWin.bind(this))
  }

  tryBuyFeature() {
    const multiplier = game.models.SpinModel.get().buy[0]
    const balance = game.models.BalanceModel.get()
    const buyPrice = game.models.BetModel.getValue() * multiplier
    if(balance < buyPrice) {
      return
    }
    const rollValue = (game.models.BetModel.getValue() * multiplier) - game.models.BetModel.getValue()
    this.roll(this.netPosition.value - rollValue, time.spin)
  }

  spin() {
    const current = game.models.SpinModel.get().current
    if(current === 'freebet' || current === 'respin' || current !== 'spin') {
      return
    }
    this.roll(this.netPosition.value - game.models.BetModel.getValue(), time.spin)
  }

  cascadeWin({ type, amount }){
    const value = this.netPosition.value + amount

    this.roll(value, time[type])
  }

  win({ type, amount }) {
    const CascadeModel = game.models.CascadeModel.get()
    let value
    if (CascadeModel.isCascade && !game.models.ModeModel.buyFeature){
      value = this.netPosition.value
    }
    else {
      value = this.netPosition.value + amount
    }

    this.roll(value, time[type])
  }

  //TODO: try to fix quick tapping

  roll(value) {
    const netPositionTween =  gsap.to(this.netPosition, 0.01, {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        netPositionTween.kill()
      },
    })

  }

  onUpdate() {
    super.update(FormatService.currency(this.netPosition.value))
  }

  gambleEnd({ type, amount }) {
    const value = amount === 0 ? this.netPosition.value - game.models.GambleModel.get().totalbet : this.netPosition.value + amount / 2
    this.roll(value, time[type])
  }
}
